import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgQAa({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10H2V12C2 6.477 6.477 2 12 2zm0 2a8 8 0 00-8 8v8h8a8 8 0 000-16zm.914 3.205a3 3 0 011.879 1.76l.064.183 2.095 6.547a1 1 0 01-1.863.719l-.041-.11-2.096-6.547a1 1 0 00-1.863-.109l-.041.11-2.096 6.547a1 1 0 01-1.934-.497l.03-.113 2.095-6.547a3 3 0 013.771-1.943zM12 13a1 1 0 110 2 1 1 0 010-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgQAa
